// extracted by mini-css-extract-plugin
export default {"editor":"LetterEditor_editor__iFJVh","textarea":"LetterEditor_textarea__3k4Yu","copy":"LetterEditor_copy__hOA0i"};